module.exports = __webpack_public_path__ + "img/icon1.fc27d8e2.png";